import unauthorized from "../../Assets/Images/unauthorized.svg"
import { Button, Col, Row } from "antd"
import { getUserRole, navigateTo } from "../../Utils/Common"

const Unauthorized = () => {
  var role = getUserRole()
  var route =
    role === "admin" || "registrar" || "accounting" || "teacher"
      ? "dashboard"
      : role === "parent"
      ? "home"
      : "login"
  return (
    <div className="h-screen w-screen flex flex-col justify-center items-center">
      <img src={unauthorized} alt="" className="w-[23rem] h-auto" />
      <div className="flex flex-col items-center w-[60%] text-center text-gray-600">
        <p className="font-bold text-2xl uppercase mt-3">Access Denied</p>
        <p className="text-sm">
          It seems you don’t have the necessary permissions to view this page.
          If you believe this is an error or you need access, please sign in
          with the correct account or contact your administrator for assistance.
        </p>
        <Row className="w-full flex justify-center" gutter={[10, 10]}>
          {role && (
            <Col xs={24} md={5}>
              <Button
                className="w-full mt-2"
                onClick={() => navigateTo(`/${route}`)}
              >
                Back to Dashboard
              </Button>
            </Col>
          )}

          <Col xs={24} md={5}>
            <Button
              type="primary"
              className="w-full mt-2"
              onClick={() => navigateTo(`/`)}
            >
              Go to Login
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default Unauthorized
